import { useMutation } from "react-query";
import URL from "core/resources/urls";
import http from "infra/http";

export function useGetImportacaoPlanoOperacional() {
  return useMutation(URL.PLANO_OPERACIONAL.OBTER_IMPORTACAO_PLANO_OPERACIONAL_ID_EXTERNO, async (filters: any) => {
    const response = await http.get(URL.PLANO_OPERACIONAL.OBTER_IMPORTACAO_PLANO_OPERACIONAL_ID_EXTERNO, {
        params: filters,
      });
    return response;
  });
}

export function useGetImportacaoPlanoOperacionalOperacao() {
  return useMutation(URL.PLANO_OPERACIONAL.OBTER_IMPORTACAO_PLANO_OPERACIONAL_OPERACAO_ID_EXTERNO('id'), async (id: string) => {
    const response = await http.get(URL.PLANO_OPERACIONAL.OBTER_IMPORTACAO_PLANO_OPERACIONAL_OPERACAO_ID_EXTERNO(id));
    return response;
  });
}

export function useGetUnidadesGEO() {
  return useMutation(URL.MAPAS.MAPA_TEXTURAS_SOLO('id', []), async (id: string) => {
    const response = await http.get(URL.MAPAS.MAPA_TEXTURAS_SOLO(id, []));
    return response;
  });
}

export function useGetUnidadesESafrasGEO() {
  return useMutation(URL.PLANO_OPERACIONAL.OBTER_MAPA('unidadeId'), async ({ unidadeId, filters }: { unidadeId: string; filters: any }) => {
    const response = await http.post(URL.PLANO_OPERACIONAL.OBTER_MAPA(unidadeId), {}, {
        params: filters,
      });
    return response;
  });
}
